'use client';

import React from 'react';
import Link from 'next/link';

export type CustomLinkProps = {
	label?: string;
	href?: string;
	onClick?: () => void;
	className?: string;
	iconNormalSrc: string;
	iconHoverSrc?: string;
	width?: number;
	height?: number;
	children?: React.ReactNode;
	labelClassName?: string;
	disableHoverOpacity?: boolean;
	'data-theme'?: string;
	/** Accessible name for icon-only links and buttons. */
	ariaLabel?: string;
};

export default function CustomLink({
	label = '',
	href,
	onClick,
	className = '',
	iconNormalSrc,
	iconHoverSrc,
	width = 24,
	height = 24,
	children,
	labelClassName = '',
	disableHoverOpacity = false,
	'data-theme': dataTheme,
	ariaLabel,
}: CustomLinkProps) {
	const classes = ['custom-link', disableHoverOpacity && 'no-hover-opacity', className].filter(Boolean).join(' ');

	const content = (
		<>
			<div className="icon-wrapper" style={{ width, height }}>
				{/* eslint-disable-next-line @next/next/no-img-element */}
				<img src={iconNormalSrc} className="icon-normal" width={width} height={height} alt="" />
				{iconHoverSrc && (
					<>
						{/* eslint-disable-next-line @next/next/no-img-element */}
						<img src={iconHoverSrc} className="icon-hover" width={width} height={height} alt="" />
					</>
				)}
			</div>
			{label && <p className={labelClassName}>{label}</p>}
			{children}
		</>
	);

	if (href) {
		return (
			<Link href={href} className={classes} onClick={onClick} aria-label={ariaLabel}>
				{content}
			</Link>
		);
	}

	if (onClick) {
		return (
			<button
				type="button"
				onClick={onClick}
				className={`custom-link ${className}`}
				data-theme={dataTheme}
				aria-label={ariaLabel}
			>
				{content}
			</button>
		);
	}

	return <div className={classes}>{content}</div>;
}
